import type { AgentState } from "@livekit/components-react";

/**
 * Older LiveKit agents do not publish the `lk.agent.state` attribute expected
 * by the current React SDK. Once a genuine agent participant is present, use a
 * neutral ready state until the agent starts publishing explicit state data.
 */
export function getCompatibleAgentState(
  state: AgentState,
  hasAgentParticipant: boolean,
): AgentState {
  if (
    hasAgentParticipant &&
    (state === "connecting" || state === "initializing")
  ) {
    return "listening";
  }

  return state;
}
